// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__K29Xc","rootNoMargin":"styles_rootNoMargin__2W79g"};